import React, { useEffect, useState, useContext } from "react";
import {
  TableContainer,
  Table,
  TableBody,
  Paper,
  TableRow,
  TableCell,
  CircularProgress,
} from "@material-ui/core";
import "./payment-history-content.component.sass";
import { useTranslation } from "react-i18next";
import { PaymentSectionInfoComponent } from "../payment-section-info/payment-section-info.component";
import { PaymentContext } from "../../store";
import { PaymentService } from "../../services/payment/payment.service";
import { PaymentHistory } from "../../types/payment-history";
import { formatDate } from "src/helpers";

export default function PaymentHistoryContentComponent() {
  const paymentService = new PaymentService();
  const [t] = useTranslation();
  const { history, setPaymentHistory } = useContext(PaymentContext);
  const [loading, setLoading] = useState(true);
  async function fetchData() {
    setLoading(true);
    const paymentHistory = await paymentService.listPaymentHistory();
    setPaymentHistory(paymentHistory);
    setLoading(false);
  }

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="payment-history">
      <div className="section-title">
        <PaymentSectionInfoComponent
          title="billing-history"
          subTitle="invoice_last_three_month"
        />
      </div>
      <div className="payment-history-content">
        <div className="table-title">{t("invoice_amount")}</div>
        <div className="table-body">
        {!history.length && !loading && (
            <div className="no-result">No Bills History Found.</div>
          )}
        {loading && !history?.length && (
            <div className="loader-area">
              <CircularProgress />
            </div>
          )}
          <TableContainer component={Paper}>
            <Table aria-label="employees table">
              <TableBody>
                {history.map((row: PaymentHistory, index: number) => (
                  <PaymentHistroyRaw index={index} info={row} key={index} />
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        {!loading && (<div className="section-footer">
          <img src="/icons/info.svg" alt="info" />
          <div className="footer-text">* {t("vat-text")}</div>
        </div> )}
      </div>
    </div>
  );
}

export const PaymentHistroyRaw = (props: any) => {
  const index = props.index;
  const info: PaymentHistory = props.info;

  const openEmployeePage = (row: any) => {};

  return (
    <TableRow
      key={index}
      onClick={openEmployeePage.bind(null, info)}
      className="payment-row"
    >
      <TableCell>{formatDate(info.date, "MMM YYYY")}</TableCell>
      <TableCell>{info.invoiceNumber}</TableCell>
      <TableCell>
        {formatDate(info.start, "MMM DD, YYYY")} - {formatDate(info.end, "MMM DD, YYYY")}
      </TableCell>
      <TableCell className="price">€ {(info.amount / 100).toFixed(2)}</TableCell>
      <TableCell>
        <a className="download-link" href={info.file} download>
          <img src="/icons/download.svg" alt="" />
        </a>
      </TableCell>
    </TableRow>
  );
};
